import React, { useState } from 'react';
import { Navbar } from '../App';
import contentPT from '../data/content.pt.json';
import contentEN from '../data/content.en.json';
import aboutPT from '../data/about.pt.json';
import aboutEN from '../data/about.en.json';

export default function About() {
  const lang = 'en';
  const content = contentEN;
  const aboutData = aboutEN;

  return (
    <>
      <Navbar brand={content.brand} />
      <main
        className="page about-page"
        style={{
          backgroundImage: "url('/fundosobrenos.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="about-container">
          <section className="about-section">
            <div className="about-content">
              <h1 className="about-title">
                We don't <span className="about-title-emphasis">GET LOST</span> <em>in</em> <span className="about-title-emphasis">TRANSLATION</span>
              </h1>
              <div className="about-copy">
                {aboutData.lines.map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
              </div>
              {aboutData.legend && (
                <div className="about-legend">
                  {aboutData.legend}
                </div>
              )}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
